export default "__VITE_PUBLIC_ASSET__74fb5c15__"